import * as screensApi from "@/apis/classroomScreen/screens";
import { usePrefetch } from "@/composables/usePrefetch";
import {
  AppNamespaceEnum,
  type ClassroomScreenInput,
} from "@/services/fobizzToolsApi";

export function useTeachingBoardScreenQueries() {
  const queryClient = useQueryClient();

  const { fetch: prefetch } = usePrefetch();

  const getQuery = (id: Ref<string>, opts = {}) => {
    return useQuery(
      {
        queryKey: [AppNamespaceEnum.CLASSROOM_SCREEN, id],
        queryFn: () => screensApi.show(id.value),
        initialData: prefetch(`classroom-screen-screen_${id.value}`),
        ...opts,
      },
      queryClient
    );
  };

  const useUpdateMutation = (id: string) => {
    return useMutation(
      {
        mutationFn: (attrs: Partial<ClassroomScreenInput>) =>
          screensApi.update(id, attrs),
        onSuccess: () => {
          queryClient.invalidateQueries({
            queryKey: [AppNamespaceEnum.CLASSROOM_SCREEN, id],
          });
        },
      },
      queryClient
    );
  };

  const refreshGetQuery = async (id: Ref<string>) => {
    if (id.value) {
      await queryClient.invalidateQueries({
        queryKey: [AppNamespaceEnum.CLASSROOM_SCREEN, id.value],
      });
    }
  };

  return {
    getQuery,
    refreshGetQuery,
    useUpdateMutation,
  };
}
